import { DataSource, IBook } from '../types/types';
import { IGetBook } from '../../../core/modules/book/book.model';

const getKey = (book: IGetBook, source: DataSource): string => {
  if (source === 'bookstat') {
    return book['ASIN'];
  }

  if (source === 'ao3') {
    return String(book['work_id']);
  }
  return book['Fiction Id'];
};

const sortPinnedTitles = (books: IGetBook[]) => (
  [...books].sort((a, b) =>
    Number(Boolean(b?.is_pinned_watchlist)) -
    Number(Boolean(a?.is_pinned_watchlist))
  )
);

const getDataSource = (
  data: IGetBook[], selectedOption = 'All Titles', source: DataSource = 'bookstat'
): IBook[] | undefined => {
  const mapBooks = (books: IGetBook[]) =>
    sortPinnedTitles(books).map(book => ({
      ...book,
      key: getKey(book, source)
    }));

  switch (selectedOption) {
  case 'All Titles':
    return mapBooks(data);

  case 'Hot Titles':
    return mapBooks(
      data?.filter(book => book.late_bloomer)
    );

  case 'Rising Stars':
    return mapBooks(
      data?.filter(book => book.is_risingstar)
    );

  default:
    return undefined;
  }
};

export default getDataSource;